import './MainPage.css'
import {Zoom} from "react-awesome-reveal";
import {useSelector} from "react-redux";
import language from "../../store/language";

const Banner = () => {
    const lang = useSelector((state) => state.user.language);

    return (
        <div className={"banner-container"}>
            <Zoom style={{width: "100%", height: "100%"}}>
                <div className={"banner-info-text"}>
                    {/* <h1 className={"banner-text-header"}>{language[lang].mainPage.banner.title}</h1> */}
                    <div className={"banner-prices"}>
                        <p className='china-air-price'>{language[lang].mainPage.banner.prices[0]}</p>
                        <p className='china-terrestrial-price'>{language[lang].mainPage.banner.prices[1]}</p>
                        <p className='china-terrestrial-price'>{language[lang].mainPage.banner.prices[2]}</p>
                        <p className='china-terrestrial-price'>{language[lang].mainPage.banner.prices[3]}</p>
                        <p className='china-terrestrial-price'>{language[lang].mainPage.banner.prices[4]}</p>
                    </div>
                </div>
            </Zoom>
        </div>
    )
}

export default Banner